import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_all",
  "use": "icon-close_all-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" viewBox=\"0 0 36 36\" id=\"icon-close_all\"><path d=\"M26 17H10a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol